import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: "I've been wanting a sleeve for years but couldn't visualize it. TATAN let me generate exactly what was in my head and try it on my arm. Mind blowing.",
  author: 'Alex M.',
  role: 'Tattoo Enthusiast'
}, {
  quote: 'As a tattoo artist, I actually use this with my clients during consultations. It helps them see the placement and scale perfectly before I make the stencil.',
  author: 'Sarah K.',
  role: 'Professional Artist'
}, {
  quote: 'The realism style generation is insane. It took my rough sketch of a lion and turned it into a masterpiece that my artist was able to use directly.',
  author: 'David R.',
  role: 'First-time Ink'
}];
export function Testimonials() {
  return <section className="py-24 bg-white/[0.02] border-y border-white/5" data-id="element-161">
      <div className="max-w-7xl mx-auto px-6" data-id="element-162">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-4xl md:text-5xl font-black tracking-tighter text-center mb-16" data-id="element-163">
          Loved by ink enthusiasts
        </motion.h2>

        <div className="grid md:grid-cols-3 gap-6" data-id="element-164">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="p-8 rounded-3xl bg-black border border-white/10 flex flex-col" data-id="element-165">
              <div className="flex gap-1 text-tatan-blue mb-6" data-id="element-166">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-current" data-id="element-167" />)}
              </div>
              <p className="text-lg text-gray-300 mb-8 flex-1 italic" data-id="element-168">
                "{testimonial.quote}"
              </p>
              <div data-id="element-169">
                <div className="font-bold text-white" data-id="element-170">{testimonial.author}</div>
                <div className="text-sm text-gray-500" data-id="element-171">{testimonial.role}</div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}